module.exports = __webpack_public_path__ + "static/media/logo-dark@2x.4e80c7be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-dark@2x.png
// module id = 668
// module chunks = 0